import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ResponsiveConstants, ScreenSizeType } from 'src/app/core';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private _subject$: BehaviorSubject<ScreenSizeType> =
    new BehaviorSubject<ScreenSizeType>('Unknown');

  public get sizeSubject$(): Observable<ScreenSizeType> {
    return this._subject$.pipe(catchError(() => EMPTY));
  }

  constructor(private breakpointObserver: BreakpointObserver) {
    const sizeLayoutArray = ResponsiveConstants.SIZE_LAYOUT_ARR;
    const screenSizeLayoutMap = ResponsiveConstants.SCREEN_SIZE_LAYOUT_MAP;

    breakpointObserver.observe(sizeLayoutArray).subscribe((result) => {
      for (const query of Object.keys(result.breakpoints)) {
        if (result.breakpoints[query]) {
          const size = screenSizeLayoutMap.get(query) ?? 'Unknown';
          this._subject$.next(size);
        }
      }
    });
  }

  public get isMobile$(): Observable<boolean> {
    return this.sizeSubject$.pipe(
      map((size) => {

        switch (size) {
          case 'Small':
            return true;

          case 'XSmall':
            return true;

          default:
            return false;
        }
      })
    );
  }
  public get isMobileScreen$(): Observable<boolean> {
    return this.sizeSubject$.pipe(
      map((size) => {

        switch (size) {

          case 'XSmall':
            return true;

          default:
            return false;
        }
      })
    );
  }
  public get isTablet$(): Observable<boolean> {
    return this.sizeSubject$.pipe(
      map((size) => {

        switch (size) {
          case 'Small':
            return true;

          default:
            return false;
        }
      })
    );
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => {
        return result.matches;
      }),
      shareReplay()
    );
}
